// @flow
import UpdateServiceModalContainer from './UpdateServiceModalContainer';

export default UpdateServiceModalContainer;
